module.exports = __webpack_public_path__ + "img/phoneicon.64fc98d6.svg";